export const BALANCE_KPIS = [
  { key: 'Resultado Líquido',         label: { pt: 'Result. Líquido',   en: 'Net Income' } },
  { key: 'Ativo Total',               label: { pt: 'Ativo Total',        en: 'Total Assets' } },
  { key: 'Patrimônio Líquido',        label: { pt: 'Patrimônio Líquido', en: 'Equity' } },
  { key: 'Rec. Liq.',                 label: { pt: 'Receita Líquida',    en: 'Net Revenue' } },
  { key: 'Resultado Básico por Ação', label: { pt: 'EPS Básico',         en: 'Basic EPS' } },
  { key: 'Passivo',                   label: { pt: 'Endividamento',      en: 'Total Debt' }, source: 'endividamento' },
];

export const TRANSLATIONS = {
  pt: {
    subtitle_sidebar: "Fatos CVM 2015",
    menu_overview: "Visão Geral e Registro",
    menu_governance: "Administração e Conselho",
    menu_shareholders: "Composição Acionária",
    menu_financials: "Finanças e Passivos",
    menu_assets: "Ativos e Concessões",
    menu_transactions: "Transações Relacionadas",
    menu_capital_changes: "Variações de Capital",
    menu_distribution: "Distribuição",
    menu_people: "Pessoas",
    menu_announcements: "Comunicados",
    footer_title: "CVM FRE - Petrobras",
    footer_ref: "Ref: Ano {year}",
    doc_subtitle: "CVM Formulário de Referência (FRE) - Ano Consolidado de {year}",
    stat_prev_close: "Fechamento Anterior",
    stat_day_change: "Variação Diária",
    stat_pe_ratio: "P/L (Preço/Lucro)",
    stat_pb_ratio: "P/VP (Preço/VPA)",
    stat_roe: "ROE (Retorno s/ Patrimônio)",
    stat_net_margin: "Margem Líquida",
    stat_div_yield: "Dividend Yield",
    stat_volatility: "Volatilidade 30d (Anual.)",
    tooltip_prev_close: "Preço de fechamento do último dia de negociação na B3.",
    tooltip_day_change: "Variação percentual do preço em relação ao fechamento do último pregão.",
    tooltip_pe_ratio: "Preço atual dividido pelo Lucro por Ação (LPA). Utiliza a cotação em tempo real e o lucro do último exercício consolidado (FRE).",
    tooltip_pb_ratio: "Preço atual dividido pelo Valor Patrimonial da Ação (VPA). Indica desconto ou prêmio sobre o patrimônio atual.",
    tooltip_roe: "Retorno sobre o Patrimônio Líquido (ROE). Reflete o último ano consolidado entregue via FRE.",
    tooltip_net_margin: "Margem Líquida. Lucro Líquido dividido pela Receita Líquida do último exercício (FRE).",
    tooltip_div_yield: "Dividendos totais do último ano divididos pelo Valor de Mercado atual (Preço x Ações).",
    tooltip_volatility: "Volatilidade Anualizada. Desvio padrão dos retornos diários dos últimos 30 pregões.",
    tooltip_eps: "Lucro por Ação (LPA). Lucro Líquido dividido pelo número de ações. Referente ao último exercício consolidado.",
    stock_title: "PETR4.SA - Preço de Mercado",
    stock_subtitle: "Feed de Preço Yahoo Finance (B3)",
    btn_hourly: "Horário",
    btn_daily: "Diário",
    btn_monthly: "Mensal",
    btn_yearly: "Anual",
    card_corp_details: "Registro e Detalhes da Companhia",
    card_auditor_officers: "Auditor e Diretores Responsáveis",
    label_audit_firm: "Firma de Auditoria",
    label_filing_responsibles: "Responsáveis pelo Envio",
    th_name: "Nome",
    th_position: "Cargo",
    card_cap_structure: "Estrutura de Capital Detalhada ({year})",
    th_cap_type: "Tipo de Capital",
    th_auth_date: "Data de Autorização",
    th_cap_val: "Valor Total do Capital",
    th_ord_shares: "Ações Ordinárias",
    th_pref_shares: "Ações Preferenciais",
    th_total_shares: "Total de Ações",
    card_board_members: "Membros da Administração e Conselheiros",
    search_placeholder: "Pesquisar por nome, cargo ou profissão...",
    th_organ: "Órgão",
    th_profession: "Profissão",
    th_elected_by: "Eleito por",
    th_term: "Prazo do Mandato",
    card_committees: "Comitês do Conselho",
    th_member_name: "Nome do Membro",
    th_committee_type: "Tipo de Comitê",
    th_age: "Idade",
    card_major_holders: "Principais Acionistas (Distribuição)",
    card_ctrl_shareholders: "Acionistas de Controle e Relacionados",
    th_holder: "Acionista",
    th_person_type: "Tipo",
    th_total_pct: "Total (%)",
    card_share_rights: "Direitos das Ações",
    th_share_class: "Classe da Ação",
    th_pref_type: "Tipo Preferencial",
    th_tag_along: "Tag Along (%)",
    th_dividend_rights: "Direito a Dividendos",
    th_voting_rights: "Direito a Voto",
    th_redemption: "Característica de Resgate/Reembolso",
    card_balance_sheet: "Contas Principais do Balanço",
    th_account_code: "Código Conta",
    th_account_desc: "Descrição da Conta",
    th_value: "Valor",
    th_scale: "Escala",
    card_debt_leverage: "Perfil de Alavancagem e Endividamento",
    label_debt_index: "Índice de Endividamento",
    label_debt_maturities: "Vencimento das Obrigações de Dívida",
    th_oblig_type: "Tipo de Obrigação",
    th_mat_1y: "Inferior 1 Ano",
    th_mat_1_3y: "1 - 3 Anos",
    th_mat_3_5y: "3 - 5 Anos",
    th_mat_5y: "Superior 5 Anos",
    th_total: "Total",
    card_intangible: "Ativos Intangíveis e Concessões",
    label_intangible_limit: "Exibindo 10 maiores de 160 registros",
    th_asset_type: "Tipo do Ativo",
    th_description: "Descrição",
    th_duration: "Duração",
    th_loss_event: "Evento de Perda de Direito",
    card_imobilizado: "Ativos Imobilizados (Propriedades e Infraestrutura)",
    label_imobilizado_limit: "Exibindo 10 maiores de 51 registros",
    th_asset_desc: "Descrição do Bem",
    th_location: "Localização (País/UF/Município)",
    th_prop_type: "Tipo de Propriedade",
    card_transactions: "Transações com Partes Relacionadas",
    label_trans_limit: "Exibindo as 25 maiores transações contratuais",
    search_placeholder_trans: "Pesquisar por parte relacionada, objeto ou garantia...",
    th_related_party: "Parte Relacionada",
    th_relation: "Relação",
    th_object: "Objeto do Contrato",
    th_amount_involved: "Montante Envolvido",
    th_balance: "Saldo Existente",
    th_duration_trans: "Duração / Rescisão",
    l_off_name: "Nome Oficial",
    l_cnpj: "CNPJ",
    l_cvm_code: "Código CVM",
    l_category: "Categoria de Envio",
    l_filing_date: "Data de Recebimento",
    l_inc_date: "Data de Constituição",
    l_corp_type: "Forma de Constituição",
    l_country: "País Sede",
    l_duration: "Prazo de Duração",
    l_aud_firm: "Firma de Auditoria",
    l_aud_cvm: "Código CVM Auditor",
    l_aud_tech: "Resp. Técnico",
    l_location: "Localização",
    l_tot_liab: "Passivo Total",
    l_debt_idx: "Índice de Endividamento (%)",
    l_idx_class: "Classificação do Índice",
    l_period: "Período Base",
    l_empty: "Sem dados para exibir.",
    l_showing_top_25: "Exibindo as 25 maiores de {total} transações.",
    modal_title: "Detalhes do Ativo",
    close: "Fechar",
    th_loss_consequence: "Consequência da Perda de Direito",
  },
  en: {
    subtitle_sidebar: "2015 CVM Filings",
    menu_overview: "Overview & Registration",
    menu_governance: "Management & Board",
    menu_shareholders: "Shareholder Structure",
    menu_financials: "Financials & Liabilities",
    menu_assets: "Assets & Concessions",
    menu_transactions: "Related Transactions",
    menu_capital_changes: "Capital Changes",
    menu_distribution: "Distribution",
    menu_people: "People",
    menu_announcements: "Announcements",
    footer_title: "CVM FRE - Petrobras",
    footer_ref: "Ref: Year {year}",
    doc_subtitle: "CVM Reference Form (FRE) - Consolidated Year {year}",
    stat_prev_close: "Previous Close",
    stat_day_change: "Day Change",
    stat_pe_ratio: "P/E Ratio",
    stat_pb_ratio: "P/B Ratio",
    stat_roe: "ROE",
    stat_net_margin: "Net Margin",
    stat_div_yield: "Dividend Yield",
    stat_volatility: "30d Volatility (Ann.)",
    tooltip_prev_close: "Closing price from the last trading day on the B3 exchange.",
    tooltip_day_change: "Percentage change in price compared to the last trading session's close.",
    tooltip_pe_ratio: "Current price divided by Earnings per Share (EPS). Uses real-time price and latest consolidated FRE earnings.",
    tooltip_pb_ratio: "Current price divided by Book Value per Share. Indicates premium/discount on the company's equity.",
    tooltip_roe: "Return on Equity (ROE). Reflects the latest consolidated year from the FRE.",
    tooltip_net_margin: "Net Margin. Net Income divided by Net Revenue from the latest fiscal year (FRE).",
    tooltip_div_yield: "Total dividends from the last year divided by the current Market Cap.",
    tooltip_volatility: "Annualized Volatility. Standard deviation of daily returns over the last 30 trading sessions.",
    tooltip_eps: "Earnings per Share (EPS). Net Income divided by outstanding shares. From the latest consolidated year.",
    stock_title: "PETR4.SA - Market Price Tracker",
    stock_subtitle: "Yahoo Finance Live Feed (B3 Exchange)",
    btn_hourly: "Hourly",
    btn_daily: "Daily",
    btn_monthly: "Monthly",
    btn_yearly: "Yearly",
    card_corp_details: "Corporate Registration & Details",
    card_auditor_officers: "Auditor & Registration Officers",
    label_audit_firm: "Auditing Firm",
    label_filing_responsibles: "Filing Responsibles",
    th_name: "Name",
    th_position: "Position",
    card_cap_structure: "Capital Structure Detail ({year})",
    th_cap_type: "Capital Type",
    th_auth_date: "Authorization Date",
    th_cap_val: "Total Capital Value",
    th_ord_shares: "Ordinary Shares",
    th_pref_shares: "Preferred Shares",
    th_total_shares: "Total Shares",
    card_board_members: "Directors & Council Officers",
    search_placeholder: "Search by name, position, or profession...",
    th_organ: "Organ",
    th_profession: "Profession",
    th_elected_by: "Elected By",
    th_term: "Term Duration",
    card_committees: "Board Committees",
    th_member_name: "Member Name",
    th_committee_type: "Committee Type",
    th_age: "Age",
    card_major_holders: "Major Shareholders (Distribution)",
    card_ctrl_shareholders: "Control Shareholders & Associates",
    th_holder: "Shareholder",
    th_person_type: "Type",
    th_total_pct: "Total (%)",
    card_share_rights: "Share Rights Details",
    th_share_class: "Share Class",
    th_pref_type: "Preferred Type",
    th_tag_along: "Tag Along (%)",
    th_dividend_rights: "Dividend Rights",
    th_voting_rights: "Voting Rights",
    th_redemption: "Redemption/Reimbursement Characteristics",
    card_balance_sheet: "Balance Sheet Key Accounts",
    th_account_code: "Account Code",
    th_account_desc: "Account Description",
    th_value: "Value",
    th_scale: "Scale",
    card_debt_leverage: "Leverage & Liabilities Profile",
    label_debt_index: "Leverage Index",
    label_debt_maturities: "Debt Obligations Maturities",
    th_oblig_type: "Obligation Type",
    th_mat_1y: "Under 1 Year",
    th_mat_1_3y: "1 - 3 Years",
    th_mat_3_5y: "3 - 5 Years",
    th_mat_5y: "Over 5 Years",
    th_total: "Total",
    card_intangible: "Intangible Assets & Concessions",
    label_intangible_limit: "Showing top 10 of 160 entries",
    th_asset_type: "Asset Type",
    th_description: "Description",
    th_duration: "Duration",
    th_loss_event: "Loss of Right Event",
    card_imobilizado: "Property, Plant & Equipment (Infrastructure)",
    label_imobilizado_limit: "Showing top 10 of 51 entries",
    th_asset_desc: "Asset Description",
    th_location: "Location (Country/State/City)",
    th_prop_type: "Property Type",
    card_transactions: "Related Party Transactions",
    label_trans_limit: "Showing top 25 major contractual records",
    search_placeholder_trans: "Search by related party, contract object, or guarantee...",
    th_related_party: "Related Party",
    th_relation: "Relation",
    th_object: "Contract Object",
    th_amount_involved: "Involved Amount",
    th_balance: "Outstanding Balance",
    th_duration_trans: "Duration / Rescission",
    l_off_name: "Official Name",
    l_cnpj: "CNPJ",
    l_cvm_code: "CVM Code",
    l_category: "Filing Category",
    l_filing_date: "Filing Date",
    l_inc_date: "Incorporation Date",
    l_corp_type: "Legal Incorporation Form",
    l_country: "Country Sede",
    l_duration: "Duration Term",
    l_aud_firm: "Auditing Firm",
    l_aud_cvm: "Auditor CVM Code",
    l_aud_tech: "Technical Lead",
    l_location: "Location",
    l_tot_liab: "Total Liabilities",
    l_debt_idx: "Debt Index (%)",
    l_idx_class: "Index Classification",
    l_period: "Base Period",
    l_empty: "No data available.",
    l_showing_top_25: "Showing top 25 of {total} transactions.",
    modal_title: "Asset Details",
    close: "Close",
    th_loss_consequence: "Consequence of Right Loss",
  },
};

export const TERM_TRANSLATIONS = {
  "Conselho de Administração": { pt: "Conselho de Administração", en: "Board of Directors" },
  "Conselho Fiscal": { pt: "Conselho Fiscal", en: "Fiscal Council" },
  "Diretoria Estatutária": { pt: "Diretoria Estatutária", en: "Board of Officers" },
  "Pertence apenas à Diretoria": { pt: "Pertence apenas à Diretoria", en: "Board of Officers only" },
  "Membro do Conselho de Administração e da Diretoria": { pt: "Membro do Conselho de Administração e da Diretoria", en: "Board of Directors & Officers" },
  "Sim": { pt: "Sim", en: "Yes" },
  "Não": { pt: "Não", en: "No" },
  "Capital Emitido": { pt: "Capital Emitido", en: "Issued Capital" },
  "Capital Subscrito": { pt: "Capital Subscrito", en: "Subscribed Capital" },
  "Capital Integralizado": { pt: "Capital Integralizado", en: "Paid-in Capital" },
  "Ordinária": { pt: "Ordinária", en: "Common (ON)" },
  "Preferencial": { pt: "Preferencial", en: "Preferred (PN)" },
  "Não se aplica": { pt: "Não se aplica", en: "N/A" },
};

export const getRolePriority = (role) => {
  if (!role) return 3;
  const lower = role.toLowerCase();
  const isVP = lower.includes('vice');
  const isPres = lower.includes('presidente') || lower.includes('president') || lower.includes('chairman');
  if (isPres && !isVP) return 1;
  if (isVP) return 2;
  return 3;
};

// Pre-computed cross-year distribution timeline — empty after static data removal
export const DISTRIBUTION_TIMELINE = [];

export const fmtBRL = (val) => {
  if (val === null || val === undefined || val === '') return '-';
  const num = parseFloat(val);
  if (isNaN(num)) return val;
  if (num >= 1e9) return `R$ ${(num / 1e9).toFixed(2)} B`;
  if (num >= 1e6) return `R$ ${(num / 1e6).toFixed(2)} M`;
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const fmtNum = (val) => {
  if (val === null || val === undefined || val === '') return '-';
  const num = parseFloat(val);
  return isNaN(num) ? val : num.toLocaleString('pt-BR');
};

export const translateTerm = (term, lang) => {
  if (term === null || term === undefined || term === '') return '-';
  const cleanTerm = String(term).trim();
  if (TERM_TRANSLATIONS[cleanTerm]) {
    return TERM_TRANSLATIONS[cleanTerm][lang] || cleanTerm;
  }
  return term;
};

export const getAge = (birthdateStr, currentYear, lang) => {
  if (!birthdateStr || typeof birthdateStr !== 'string') return '-';
  const match = birthdateStr.match(/^(\d{4})/);
  if (!match) return '-';
  const birthYear = parseInt(match[1]);
  const age = currentYear - birthYear;
  if (isNaN(age) || age < 0 || age > 120) return '-';
  return `${age} ${lang === 'pt' ? 'anos' : 'years'}`;
};
